import * as styles from "./styles";
import { MessageProps } from "./types";

export const Message = ({
  children,
  className = "",
  ...props
}: MessageProps) => {
  return (
    <article className={`message ${styles.article} ${className}`} {...props}>
      <p className={`${styles.p}`}>{children}</p>
    </article>
  );
};
